<template>
    <date-range-picker-2
        ref="picker"
        :locale-data="{ firstDay: 1, format: 'DD-MM-YYYY' }"
        :date-range="dateRange"
        :minDate="minDate" :maxDate="maxDate"
        :showWeekNumbers=true
        :showDropdowns=true
        :autoApply=true
        v-model="dateRange"
        @select="emitDateRangeSelected"
    >
        <template v-slot:input="picker" style="min-width: 350px;" id="analytics-date-picker">
            {{ picker.startDate.toLocaleDateString() }} - {{ picker.endDate.toLocaleDateString() }}
        </template>
    </date-range-picker-2>
</template>

<script>
    import DateRangePicker from 'vue2-daterange-picker/src/components/DateRangePicker';

    export default { 
        name: "AnalyticsDateRangePicker",
        components: { "date-range-picker-2": DateRangePicker },
        emits: ['dateRangeSelected'],
        data() {
            let startDate = new Date();
            startDate.setMonth(startDate.getMonth() - 3);
            let endDate = new Date();
            const minDate = '2020-01-01';
            const maxDate = new Date();
            const date = new Date();
            return {
                dateRange: {startDate, endDate},
                minDate: minDate,
                maxDate: maxDate,
                date: date
            }
        },
        methods: {
            emitDateRangeSelected (e) {
                //console.log(e);
                this.$emit('dateRangeSelected', e);
            }
        }
    };
</script>